import React from 'react';
import './InstitutionDetails.css';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import SearchSuggest from '../shared/search-suggest/SearchSuggest';
import StepForm from "../state-transition/StateTransition";
import {
  addNewRowInstitute,
  deleteRowInstitute,
  instituteHandleChange,
  updateEmptyFlagInstitute,
  updateDuplicateFlagInstitute,
  updateInstitutionDetailsFlag,
  getInstitutions,
  saveInstitutionDetails,
  setShowLoaderStatus,
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails
} from './../../redux-building-blocks/actions';

import { isEmpty } from "lodash";
import { constants } from '../../constants';
import { CreditRecognitionTable } from './credit-recognition-table/CreditRecognitionTable';
import MulesoftDataService from '../../services/mulesoftData.services';

export class InstitutionDetails extends React.Component {
  constructor(props) {
    super(props)
    this.searchHandler = this.searchHandler.bind(this)
    this.state={
      creditRecognitionRelatedData:[{
        data:[],
        showCreditDetails:false,
        showAllRecords:false,
        noCredits:false,
        policyDescription:'',
        instituteId:''
      }]
    }
  }

  componentDidMount() {
    if(isEmpty(this.props.institutionApivalues)) {
      this.props.getInstitutions();
    }

    //When come back to insitute through navigation
    if(this.state.creditRecognitionRelatedData.length < this.props.institutesDetailList.length){
      let creditRecognitionRelatedData = this.state.creditRecognitionRelatedData;
      this.props.institutesDetailList.forEach((instituteDetail,index)=>{
        if(!creditRecognitionRelatedData[index]){
          creditRecognitionRelatedData[index]={data: [],showCreditDetails: false, showAllRecords: false,policyDescription:''}
        }
      }) 
      this.setState({creditRecognitionRelatedData});
    }
  }

  componentDidUpdate(previousProps, previousState) {
    let creditRecognitionRelatedData = this.state.creditRecognitionRelatedData;
    let isAnyUpdateForCreditRecognitionData = false;

    // New Institute is Added
    if (previousProps.institutesDetailList.length<this.props.institutesDetailList.length) {
      this.props.institutesDetailList.forEach((instituteDetail,index)=>{
        if(!creditRecognitionRelatedData[index]){
          creditRecognitionRelatedData[index]={data: [],showCreditDetails: false, showAllRecords: false,policyDescription:''}
          isAnyUpdateForCreditRecognitionData = true;
        }
      }) 
    }

    //Institue name is modified
    if (previousProps.institutesDetailList.length===this.props.institutesDetailList.length) {
      this.props.institutesDetailList.forEach((instituteDetail,index)=>{
        if(instituteDetail.id === previousProps.institutesDetailList[index].id && instituteDetail.ResultsTeamChildId !==  previousProps.institutesDetailList[index].ResultsTeamChildId){
          creditRecognitionRelatedData[index]={data: [],showCreditDetails: false, showAllRecords: false,policyDescription:''}
          isAnyUpdateForCreditRecognitionData = true;
        }
      }) 
    }

    if(isAnyUpdateForCreditRecognitionData){
      this.setState({creditRecognitionRelatedData});
    }

}
  reDirectToHistory = () => {
    this.props.resetPersonalInfoData();
    this.props.restExamDetails();
    this.props.restInstitutionDetails();
    this.props.history.push('/transcript-history')
  }

  handleSubmit = event => {
    for (let i = 0; i < this.props.institutesDetailList.length; i++) {
      console.log('val',this.props.institutesDetailList[i].ResultsTeamChildId);
      if (this.props.institutesDetailList[i].institute === "") {
        this.props.updateEmptyFlagInstitute("true" ,this.props.institutesDetailList[i].id);
      }
      else {
        this.props.updateEmptyFlagInstitute("false" ,this.props.institutesDetailList[i].id);
      }
    }
    setTimeout(() => {
      const emptyFlag = this.props.institutesDetailList.some(item => item.emptyValueFlag === "true");
      const duplicateFlag = this.props.institutesDetailList.some(item => item.duplicateValueFlag === "true");
      if(emptyFlag === false && duplicateFlag === false){
        this.props.setShowLoaderStatus(true);
        const payload = {
          transactionId: this.props.transactionId,
          transactionStatus: "inProgress",
          identifiers: this.props.institutesDetailList
        }; 
        this.props.saveInstitutionDetails(payload, () => {
          this.props.history.push('/review');
        })
      }else {
          this.handleValidation(uuidv4());
      }
    },0);
    
  }

  handleValidation = (event) => {
    
  
    if (this.props.institutesDetailList.length > 1) {
      let valuesObject = {};
      var duplicateArray=[];
      for (let i = 0; i < this.props.institutesDetailList.length; i++) {
        valuesObject.institute = (this.props.institutesDetailList[i].institute !== '') ? this.props.institutesDetailList[i].institute : 'Empty';
        for (let j = i + 1; j < this.props.institutesDetailList.length; j++) {
          if ((valuesObject.institute === this.props.institutesDetailList[j].institute)) {
            duplicateArray.push(this.props.institutesDetailList[j].id);
          }
        }
      }
      if(duplicateArray.length > 0){
        this.props.institutesDetailList.forEach(
          (item, i) => {
            if(duplicateArray.includes(item.id)){
              this.props.updateDuplicateFlagInstitute("true" ,item.id);
            } else{
              this.props.updateDuplicateFlagInstitute("false" ,item.id);
            }
          }
      )
      } else {
    this.props.institutesDetailList.forEach(
      (item, i) => {
        this.props.updateDuplicateFlagInstitute("false" ,item.id);
        }   
  )
  }
            }
  };

  searchHandler(value, index) {
    if(value==null){
      this.props.instituteHandleChange({
        dataValue: '',
        dataID: ''
      }, index);
      this.props.updateEmptyFlagInstitute("true" ,index);
      setTimeout(() => {
        this.handleValidation(uuidv4());
      },0);
      
    }else{      
    this.props.instituteHandleChange(value, index);
    this.props.updateEmptyFlagInstitute("false" ,index);
    setTimeout(() => {
      this.handleValidation(uuidv4());
    },0);
    }      
  }

  deleteInstitute(id){
    this.props.deleteRowInstitute(id);
    let index = this.state.creditRecognitionRelatedData.findIndex(c=>c.instituteId === id);
    this.state.creditRecognitionRelatedData.splice(index,1);
    setTimeout(() => {
      this.handleValidation(uuidv4());
    },0);
  }

  showCreditPolicy(index,id){
    let creditRecognitionRelatedData = this.state.creditRecognitionRelatedData;
    
    if(!creditRecognitionRelatedData[index].showCreditDetails){
      creditRecognitionRelatedData[index].showCreditDetails = true;
    }

    if(creditRecognitionRelatedData[index].showCreditDetails){

      if((this.props.institutesDetailList[index].InstituteIdentifier === 'NULL') || (this.props.institutesDetailList[index].InstituteIdentifier === '')){
        creditRecognitionRelatedData[index].noCredits = true;
        this.setState({creditRecognitionRelatedData});
      }else {
        MulesoftDataService.getCreditandRecognition(this.props.institutesDetailList[index].InstituteIdentifier,this.props.transactionId)
        .then(data=>{
          if(data.length ===0){
            creditRecognitionRelatedData[index].noCredits = true;
            creditRecognitionRelatedData[index].instituteId = id;
            this.setState({creditRecognitionRelatedData});
          }
          else if(data[0] && data[0].types && data[0].types.length>0){
            creditRecognitionRelatedData[index].data= data[0].types;
            creditRecognitionRelatedData[index].policyDescription= data[0].policyDescription;
            creditRecognitionRelatedData[index].instituteId = id;
            this.setState({creditRecognitionRelatedData})
          }
        })
      }      
    }
    

  }

  showAll(index){
    let creditRecognitionRelatedData = this.state.creditRecognitionRelatedData;
    creditRecognitionRelatedData[index].showAllRecords = !creditRecognitionRelatedData[index].showAllRecords;
    this.setState({creditRecognitionRelatedData})
  }

  render() {

    var institutionApivaluesList = (this.props.institutionApivalues &&
      this.props.institutionApivalues.length) ? [...this.props.institutionApivalues] :
      [];
    let filteredData = institutionApivaluesList.filter(item => {
      return ((item.CIEDirectAccountCode && item.CIEDirectAccountCode.toLowerCase() !== "xxxxx") &&
      (item.LocationType && item.LocationType.toLowerCase().trim() === "institution"))
    });
    
    return (
      <React.Fragment>
        <div className="w-100">
        <StepForm pathname={this.props.location.pathname}></StepForm>
          <label className="h3Size mb-0.6"><b>Institution details</b><span className="error h3Size">&nbsp;*Required</span></label>
          {this.props.institutesDetailList.map((value, index) => {
              let noCreditTabularData =  this.state.creditRecognitionRelatedData[index]?.data.length === 1?
                                       Object.values(this.state.creditRecognitionRelatedData[index].data[0]).every(v => v === null):false;            
              const {creditRecognitionRelatedData} = this.state;
              const {POLICY_PARSE,POLICY_PARSE_REPLACE} = constants.CREDITS_AND_RECOGNITION;
              
              if(creditRecognitionRelatedData[index]?.policyDescription){
                for(let x of POLICY_PARSE){
                  if(creditRecognitionRelatedData[index].policyDescription.match(x)){
                    let z = POLICY_PARSE_REPLACE.filter(e=>String(e.key) === String(x));
                    if(z.length){
                      creditRecognitionRelatedData[index].policyDescription = creditRecognitionRelatedData[index].policyDescription.replaceAll(x,z[0].val);
                    }else{
                      creditRecognitionRelatedData[index].policyDescription = creditRecognitionRelatedData[index].policyDescription.replaceAll(x," ");
                    }
                  }
                }
              } 
              return (
              <div key={value.id} className={(value.duplicateValueFlag === "true") ? "card border-danger mt-2 pb-2" : "card mt-2 pb-2"}>
                <form>
                  <div className="card-body px-0 py-1">
                    {index !== 0 ? <button type="button" className="btn crossButtonInstitution py-0" id="deleteInstituteButton"
                      onClick={() => this.deleteInstitute(value.id)}>&#x2716;</button> : ""}
                    <div className="mb-2 padRight">
                        <small className="form-text text-muted textWidth mt-3">
                          Please choose your US institution below and then select 'Save and continue' located below. You may also select 'Show credit table' to see how the institution awards course credit for your passing exams.
                        </small>
                      </div>
                    <div className="row row-group pl-3">
                    <div className="col-lg-5 col-sm-8 col-md-6 col-7 mb-0 d-flex">
                      <SearchSuggest noOfOptionToConsider={100} dataList={filteredData} searchHandler = {this.searchHandler} index={value.id} minCharToStartSearch={5}
                        label="Institution" placeholder="Search by name" initialValue={value.institute} haveError={this.props.institutesDetailList[index].emptyValueFlag}
                      />
                     
                    </div>
                      <div className="col-lg-4 col-md-4 col-sm-4 col-5 ">
                      <button 
                        type='button' 
                        id="showCreditPolicy"
                        className="btn btn-primary font-weight-bold credit-policy-button"
                        disabled={!this.props.institutesDetailList[index].showCreditPolicyButton} 
                        onClick={()=>{this.showCreditPolicy(index,value.id)}}>
                          Show credit table
                        </button>
                      </div>
                    </div>
                    {this.props.institutesDetailList[index].emptyValueFlag === "true"&& (
                    <div className="mb-2 padRight">
                        <small className="form-text padLeft errorLabelInstitute">
                          Please select an institution.
                        </small>
                      </div>
                      )}
                      {this.props.institutesDetailList[index].duplicateValueFlag === "true"&& (
                    <div className="mb-2 padRight">
                        <small className="form-text padLeft errorLabelInstitute">
                        Please remove duplicate listings of an institution. You can only list an institution once.
                        </small>
                      </div>
                      )}

                    {/* START OF CREDIT AND RECOGNITION */}
                    {this.state.creditRecognitionRelatedData[index]?.showCreditDetails &&
                      <div className="credit-policy-container mt-3">

                        {/* SHOW THE MESSAGE IF THERE IS NO CREDITS AND RECOGNITION */}
                        {this.state.creditRecognitionRelatedData[index]?.noCredits &&
                          <p id="noCreditMessage">{constants.CREDITS_AND_RECOGNITION.NO_CREDITS_MESSAGE}</p>
                        }

                         {/* CREDITS AND RECOGNITION DATA*/}
                        {!this.state.creditRecognitionRelatedData[index].noCredits &&
                        <div className="credit-policy-sub-container">
                          <div className="text-justify">
                            <div className="font-weight-bold">Cambridge International AS & A Level and Cambridge AICE Diploma</div>
                            {this.state.creditRecognitionRelatedData[index].policyDescription}
                          </div>
                          {!noCreditTabularData &&
                            <>
                            <div className="font-weight-bold mt-2">Credit and placement by course</div>

                            <CreditRecognitionTable 
                            data={this.state.creditRecognitionRelatedData[index].showAllRecords?this.state.creditRecognitionRelatedData[index].data: this.state.creditRecognitionRelatedData[index].data.slice(0,5)} 
                            showAllRecords={this.state.creditRecognitionRelatedData[index].showAllRecords}
                            index={index}
                            />

                            <button 
                            type='button'
                            id="showAllPolicies" 
                            className="btn-link font-weight-bold text-decoration-none show-hide-btn" 
                            onClick={()=>{this.showAll(index)}}> 
                            {this.state.creditRecognitionRelatedData[index].showAllRecords?'Hide >>':'Show All >>'}
                            </button>
                            </>
                          }

                          <p className="font-italic font-weight-bold mt-3">Refer to institution website for official and current policy information.</p>
                        </div>
                        }
                      </div>
                    }
                    {/* END OF CREDIT AND RECOGNITION */}

                    {this.props.institutesDetailList.length === (index + 1) &&
                      <div className="mb-2 padRight">
                        <small className="form-text text-muted padLeft">
                          University, college, or other
                        </small>
                        <small className="form-text text-muted textWidth mt-2">
                          If your US institution is not listed please contact <a href='mailto:UShighered@cambridgeinternational.org' style={{ textDecoration: 'underline' }}>UShighered@cambridgeinternational.org</a>. Please include your name and the name and address of the institution to which you are sending a transcript, and the contact information of your admissions counselor or advisor, if available.
                        </small>
                        <small className="form-text text-muted textWidth mt-3">
                          <b>Make sure you have selected all series which you want to send results for. If you are not sure, or wish to add or remove any, return to the Exam details tab.</b>
                        </small>
                        <small className="form-text text-muted textWidth mt-3">
                          This form allows you to send grade transcripts to one or more institutions. If you wish to send results from a different exam series to a different institution, you should finish the current request, and then fill out the form again.
                        </small>
                      </div>
                    }
                    
                    
                  </div>
                </form>
              </div>
            );
          })}
          {this.props.institutesDetailList.length < 6 &&
            <div className="addNewInstitutionActive" onClick={this.props.addNewRowInstitute} id="addNewInstitute">
              <b>+Add another institution</b>
            </div>}
          <div className="">
            <button type="button" onClick={(event) => this.handleSubmit(event)} id="instituteSubmitButton" className="btn btn-primary font-weight-bold save-button-institute mr-3">
            Save and continue
            </button>            
            <button onClick={this.reDirectToHistory} type="button" className="btn btn-link font-weight-bold text-decoration-none"><span>Cancel</span></button>
            
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    institutesDetailList: state.institutesDetailsInfo.institutesDetailList,
    institutionApivalues : state.institutesDetailsInfo.institutionApivalues,
    institutionDetailsInfoFlag : state.stateTransition.isInstitutionDetailsCrossed,
    transactionId: state.commonData.transactionId   
  };
};

const mapDispachToProps = {
    addNewRowInstitute,
    deleteRowInstitute,
    instituteHandleChange,
    updateInstitutionDetailsFlag,
    updateDuplicateFlagInstitute,
    updateEmptyFlagInstitute,
    getInstitutions,
    saveInstitutionDetails,
    setShowLoaderStatus,
    resetPersonalInfoData,
    restExamDetails,
    restInstitutionDetails
};

export default withRouter(connect(
  mapStateToProps, mapDispachToProps
)(InstitutionDetails));
